import React, { useEffect, useState } from "react";
import { 
  Box, Button, Center, Flex, Input, Spinner, Table, 
  Tbody, Td, Th, Thead, Tr, useToast 
} from "@chakra-ui/react";
import { updateCompanySettings } from "../../api/updateCompanySettings";
import { getCompanySettings } from "../../api/getCompanySettings";
import { getCompanies } from "../../api";

const CompanySettings = () => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [timestamps, setTimestamps] = useState({});
  const [isSaving, setIsSaving] = useState({});
  const toast = useToast();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [companiesRes, settingsRes] = await Promise.all([
        getCompanies(),
        getCompanySettings()
      ]);
      setCompanies(companiesRes || []);

      const initialTimestamps = {};
      settingsRes.forEach(setting => {
        initialTimestamps[setting.cif] = setting.monthClosureTimestamp
          ? new Date(setting.monthClosureTimestamp).toISOString().slice(0, 7)
          : "";
      });
      setTimestamps(initialTimestamps);
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to load data.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleTimestampChange = (cif, value) => {
    setTimestamps(prev => ({ ...prev, [cif]: value }));
  };

  const handleSave = async (cif) => {
    setIsSaving(prev => ({ ...prev, [cif]: true }));
    const timestampInMillis = new Date(timestamps[cif] + "-15").getTime();
    const response = await updateCompanySettings({ cif: cif, monthClosureTimestamp: timestampInMillis });

    toast({
      title: response.success ? "Saved" : "Error",
      description: response.message,
      status: response.success ? "success" : "error",
      duration: 3000,
      isClosable: true,
    });

    setIsSaving(prev => ({ ...prev, [cif]: false }));

    if (response.success) {
      fetchData();
    }
  };

  return (
    <Box overflowX="auto" minHeight="250px">
      {loading ? (
        <Center height="300px" bg="gray.100">
          <Spinner size="xl" />
        </Center>
      ) : (
        <Table variant="striped" size="sm">
          <Thead>
            <Tr>
              <Th>#</Th>
              <Th>Denumire</Th>
              <Th>Dată închidere de lună</Th>
            </Tr>
          </Thead>
          <Tbody>
            {companies.length > 0 ? (
              companies.map((company) => (
                <Tr key={company.id}>
                  <Td>{company.id}</Td>
                  <Td>{company.name}</Td>
                  <Td>
                    <Flex gap="3" align="center">
                      <Input
                        height="30px"
                        width="80%"
                        type="month"
                        value={timestamps[company.cif] || ""}
                        onChange={(e) => handleTimestampChange(company.cif, e.target.value)}
                      />
                      <Button
                        width="20%"
                        colorScheme="green"
                        variant="outline"
                        _hover={{ bg: "green.500", color: "white" }}
                        size="xs"
                        isDisabled={isSaving[company.cif]}
                        isLoading={isSaving[company.cif]}
                        onClick={() => handleSave(company.cif)}
                      >
                        Salvează
                      </Button>
                    </Flex>
                  </Td>
                </Tr>
              ))
            ) : (
              <Tr>
                <Td colSpan={4} textAlign="center">
                  Nu există date
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      )}
    </Box>
  );
};

export default CompanySettings;
